import { render } from "./UploadAvatar.vue?vue&type=template&id=420ca41b&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=ts"
export * from "./UploadAvatar.vue?vue&type=script&lang=ts"

import "./UploadAvatar.vue?vue&type=style&index=0&id=420ca41b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-420ca41b"

export default script